// extracted by mini-css-extract-plugin
export default {"speechBubble":"SceneOverlay_speechBubble__iptHw","left":"SceneOverlay_left__1cc2d","iconButton":"SceneOverlay_iconButton__6VenV"};